import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { useTheme } from '@mui/styles';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

export const AppInstallableCard = () => {
  const [ , dispatch ] = useContext(AppContext);
  const theme = useTheme()

  const handleDismissClick = () => {
    dispatch({type: 'app/ui/card/appInstallable', value: 'dismissed'});
  }

  const handleInstallClick = () => {
    dispatch({type: 'app/ui/control/appInstallTrigger', value: true});
  }

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms'}}>
      <Card sx={{
          border: '1px solid',
          borderColor: theme.palette.primary.main,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          paddingX: 2,
          boxShadow: "none",
          alignItems: "left",
          justifyContent: "left"
        }}>
        <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
                <DownloadForOfflineIcon color={"primary"} sx={{fontSize:50, color: theme.palette.primary.main}}/>
              </Avatar>
            }
            title="Information"
            subheader={"Install NFC Config"}
            titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
        />
        <CardContent sx={{mt:0, pt:0, pb:0}}>
          <Typography variant="body2" color="text.secondary">
            This will allow you to launch the app from the homescreen later, even when you are offline.
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            onClick={handleInstallClick}
          >
            Install
          </Button>
          <Button
            color="primary"
            onClick={handleDismissClick}
          >
            Dismiss
          </Button>
        </CardActions>
      </Card>
    </Zoom>
  )
}

export default AppInstallableCard;
